import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15.566 9.248C14.581 8.298 12.737 7 10 7S5.419 8.298 4.434 9.248C4.116 9.554 4 9.731 4 10s.116.445.434.752C5.419 11.702 7.263 13 10 13s4.581-1.298 5.566-2.248c.318-.306.434-.54.434-.752s-.116-.445-.434-.752zM11 9c0 .551-.449 1-1 1s-1-.449-1-1 .449-1 1-1 1 .449 1 1zm-1 3c-2.437 0-4.061-1.173-4.903-1.996.609-.592 1.626-1.368 3.053-1.758-.095.233-.149.487-.149.754 0 1.105.895 2 2 2s2-.895 2-2c0-.269-.055-.524-.151-.758 1.434.387 2.447 1.161 3.054 1.754-.847.822-2.481 2.004-4.903 2.004z',
  ],
  height: 20,
  width: 20,
});
